import { render, staticRenderFns } from "./template-content.vue?vue&type=template&id=2aee6604&scoped=true"
import script from "./template-content.vue?vue&type=script&lang=ts"
export * from "./template-content.vue?vue&type=script&lang=ts"
import style0 from "./template-content.vue?vue&type=style&index=0&id=2aee6604&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aee6604",
  null
  
)

export default component.exports